import { ButtonGroup as UIButtonGroup } from "@gluestack-ui/themed";

import { ButtonGroupProps } from "./types";
import { FormControl } from "../FormControl";
import { OptionButton } from "./components/OptionButton";
export const ButtonGroup = ({
  options,
  value,
  onChange,
  isDisabled,
  isInvalid,
  type,
  isReadOnly,
  isRequired,
  errorMessage,
  isLoading,
  label,
  helperText
}: ButtonGroupProps) => {
  const handleOnChange = (nextValue: string) => {
    onChange?.(nextValue);
  };
  return (
    <FormControl
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
      errorMessage={errorMessage}
      helperText={helperText}
      isLoading={isLoading}
      label={label}
    >
      <UIButtonGroup width="$full" flexWrap="nowrap">
        {options?.map((opt) => {
          return (
            <OptionButton
              type={type}
              key={opt.label}
              text={opt.label}
              isActive={opt.value === value}
              onPress={() => handleOnChange?.(opt.value)}
            />
          );
        })}
      </UIButtonGroup>
    </FormControl>
  );
};
